/** The RecruitTrucker brand mark (the amber "R" badge). Square; sized in px. */
export function Logo({ size = 28, className = "" }: { size?: number; className?: string }) {
  return (
    <img
      src="/logo.png"
      alt="RecruitTrucker"
      width={size}
      height={size}
      className={`rounded-md ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
